/* Global Copy Function triggered directly inline (bypasses click interception & morphing) */
window.copyCouponCode = function (btn, code, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function copyTextToClipboard(text) {
    return new Promise(function (resolve, reject) {
      // 1. Try modern clipboard API first
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(resolve)
          .catch(function () {
            // Fallback if browser blocks clipboard API (e.g. document focus or permission denied)
            runFallbackCopy(text, resolve, reject);
          });
      } else {
        runFallbackCopy(text, resolve, reject);
      }
    });

    function runFallbackCopy(text, resolve, reject) {
      var textArea = document.createElement("textarea");
      textArea.value = text;
      
      // Position off-screen but still focusable
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "-9999px";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = "0";
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      textArea.setAttribute("readonly", ""); // Avoid mobile virtual keyboard zoom
      
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        var successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (successful) {
          resolve();
        } else {
          reject(new Error('execCommand returned false'));
        }
      } catch (err) {
        document.body.removeChild(textArea);
        reject(err);
      }
    }
  }

  copyTextToClipboard(code).then(function () {
    var originalHTML = btn.innerHTML;
    btn.innerHTML = '<span class="coupon-card__copied-badge">Copied!</span>';

    setTimeout(function () {
      btn.innerHTML = originalHTML;
    }, 2000);
  }).catch(function (err) {
    console.error('Failed to copy to clipboard', err);
  });
};

(function () {
  'use strict';

  var COUPON_CODE = 'WELCOME108';
  var cachedRecommendations = null;

  function init() {
    initGiftCardBanner();
    initRecommendations();

    if (window.LuxuryCartSummaryInitialized) {
      if (window.syncLuxuryCartSummaryUI) {
        window.syncLuxuryCartSummaryUI();
      }
      return;
    }
    window.LuxuryCartSummaryInitialized = true;
    window.syncLuxuryCartSummaryUI = syncUIWithCart;

    /* Initialize MutationObserver to catch morphing updates instantly */
    initMutationObserver();    /* Clean up URL parameter if loaded from a reload redirect */
    if (window.location.search.indexOf('reload-cart=true') !== -1) {
      var cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
    }

    /* Sync chip UI with real cart on load */
    syncUIWithCart();

    /* Automatically open cart drawer if flagged after reload */
    if (localStorage.getItem('openCartDrawer') === 'true') {
      localStorage.removeItem('openCartDrawer');
      // Click the trigger instantly to hook event listeners and setup Native dialog accessibility state
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
      }
      // Remove blocking temp stylesheet to restore standard visual sliding animations
      var tempStyle = document.getElementById('TempCartOpenStyle');
      if (tempStyle) {
        tempStyle.remove();
      }
    }

    /* Event delegation for all interactive elements */
    document.addEventListener('click', function (e) {
      var target = e.target;

      // 0. Clicked color variant swatch inside recommendations card
      var swatch = target.closest('.luxury-rec-card__color-swatch');
      if (swatch) {
        e.preventDefault();
        e.stopPropagation();

        var newImgSrc = swatch.getAttribute('data-image');
        var variantId = swatch.getAttribute('data-variant-id');
        var card = swatch.closest('.luxury-rec-card');
        
        if (card) {
          var swatches = card.querySelectorAll('.luxury-rec-card__color-swatch');
          for (var s = 0; s < swatches.length; s++) {
            swatches[s].classList.remove('active');
          }
          swatch.classList.add('active');

          if (newImgSrc) {
            var img = card.querySelector('.luxury-rec-card__image-wrapper img');
            if (img) {
              img.src = newImgSrc;
            }
          }

          if (variantId) {
            var currentHref = card.getAttribute('href');
            var baseHref = currentHref.split('?')[0];
            card.setAttribute('href', baseHref + '?variant=' + variantId);
          }
        }
        return;
      }

      // 1. Manual Apply Promo Button
      var applyBtn = target.closest('#LuxuryPromoApply');
      if (applyBtn) {
        handleManualApply(e);
        return;
      }

      // 2. Coupon Chip Click
      var couponChip = target.closest('#LuxuryCouponChip');
      if (couponChip) {
        handleChipClick(e);
        return;
      }

      // 3. Remove Coupon Pill Button
      var removeBtn = target.closest('.luxury-coupon-pill__remove');
      if (removeBtn) {
        e.preventDefault();
        handleRemoveDiscount();
        return;
      }

      // 4. Cart Mutation Click (Quantity changes or item removals inside drawer)
      var isRemoveBtn = target.closest('.luxury-cart-item__remove') ||
        target.closest('cart-remove-button');

      if (isRemoveBtn) {
        localStorage.setItem('openCartDrawer', 'true');
        return;
      }
    });

    /* Listen for theme cart events (item remove, qty change, etc.) */
    var cartEvents = [
      'cart:refresh', 'cart:updated', 'cart:change', 'cart:update',
      'cart-drawer:open', 'cart-drawer:refreshed',
      'on:cart:change', 'theme:cart:updated', 'discount:update'
    ];
    cartEvents.forEach(function (evt) {
      document.addEventListener(evt, syncUIWithCart);
    });
  }

  /* ─── Core: apply discount with NO redirect ─────────────────── */
  function applyDiscountSilently(code) {
    return new Promise(function (resolve, reject) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          discount: code,
          attributes: {
            'discount_code': code,
            'applied_discount': code,
            'coupon_code': code
          }
        })
      })
        .then(function () {
          return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/', {
            method: 'GET',
            credentials: 'include',
            redirect: 'follow'
          });
        })
        .then(function () {
          setTimeout(function () {
            fetchCart().then(resolve).catch(reject);
          }, 400);
        })
        .catch(reject);
    });
  }

  /* ─── Remove discount silently ──────────────────────────────── */
  function removeDiscountSilently() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        discount: '',
        attributes: {
          'discount_code': '',
          'applied_discount': '',
          'coupon_code': ''
        }
      })
    })
      .then(function () {
        return fetch('/discount/?redirect=/', {
          method: 'GET',
          credentials: 'include',
          redirect: 'follow'
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: 'luxury-cart-summary',
            data: {
              sections: {}
            }
          }
        }));
        return new Promise(function (res) { setTimeout(res, 400); });
      });
  }

  /* ─── Fetch live cart ───────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  /* ─── Get all applied discount codes from cart payload ──────── */
  function getAppliedDiscountCodes(cart) {
    var codes = [];
    if (cart.cart_level_discount_applications) {
      cart.cart_level_discount_applications.forEach(function (d) {
        if (d.title) codes.push(d.title.toUpperCase());
      });
    }
    if (cart.items) {
      cart.items.forEach(function (item) {
        if (item.line_level_discount_allocations) {
          item.line_level_discount_allocations.forEach(function (alloc) {
            if (alloc.discount_application && alloc.discount_application.title) {
              codes.push(alloc.discount_application.title.toUpperCase());
            }
          });
        }
      });
    }
    if (cart.attributes) {
      if (cart.attributes.discount_code) codes.push(cart.attributes.discount_code.toUpperCase());
      if (cart.attributes.applied_discount) codes.push(cart.attributes.applied_discount.toUpperCase());
      if (cart.attributes.coupon_code) codes.push(cart.attributes.coupon_code.toUpperCase());
    }
    return codes.filter(function (value, index, self) {
      return self.indexOf(value) === index && value && value.trim() !== '';
    });
  }

  function syncUIWithCart() {
    fetchCart().then(function (cart) {
      var appliedCodes = getAppliedDiscountCodes(cart);
      var applied = appliedCodes.length > 0;
      var empty = cart.item_count === 0;

      if (empty && applied) {
        removeDiscountSilently().then(function () {
          sessionStorage.removeItem('luxuryCouponApplied');
          setDefaultState();
          updateTotalDisplay(0);
          renderAppliedCoupons([]);
        });
        return;
      }

      applied ? setAppliedState(appliedCodes) : setDefaultState();
      updateTotalDisplay(cart.total_price);
      renderAppliedCoupons(appliedCodes);
    }).catch(function () { });
  }

  /* ─── Fetch and Render Gift Card Banner ─────────────────────── */
  function initGiftCardBanner() {
    var banner = document.getElementById('LuxuryGiftCardBanner');
    if (!banner) return;
    banner.style.display = 'flex';
  }

  /* ─── Fetch and Render Recommended Products ─────────────────── */
  function initRecommendations() {
    window.LuxuryRecommendationsFetching = false;

    window.refreshRecommendations = function () {
      if (window.LuxuryRecommendationsFetching) return;

      var activeContainer = document.getElementById('LuxuryRecommendations');
      var activeSlider = document.getElementById('LuxuryRecommendationsSlider');
      if (!activeContainer || !activeSlider) return;

      // If we already have recommendations cached, render them directly without dynamic fetching
      if (cachedRecommendations) {
        renderProducts(cachedRecommendations);
        return;
      }

      window.LuxuryRecommendationsFetching = true;

      fetchCart().then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          fetchFallbackProducts();
          return;
        }

        // If the container already has content, keep it visible while updating to prevent flickers
        if (activeSlider.querySelector('.luxury-rec-card')) {
          activeContainer.style.display = 'block';
        }

        // Filter out the gift card to find the previous/original product
        var targetProduct = null;
        for (var k = 0; k < cart.items.length; k++) {
          var item = cart.items[k];
          if (item.handle !== 'ekatra-jewels-gift-card' && (!item.url || item.url.indexOf('ekatra-jewels-gift-card') === -1)) {
            targetProduct = item;
            break;
          }
        }

        var finalProduct = targetProduct || cart.items[0];
        var lastProductId = finalProduct.product_id;

        fetch('/recommendations/products.json?product_id=' + lastProductId + '&limit=5')
          .then(function (r) {
            if (!r.ok) throw new Error('Failed to fetch recommendations');
            return r.json();
          })
          .then(function (data) {
            var products = data.products || [];
            if (products.length === 0) {
              fetchFallbackProducts();
              return;
            }
            renderProducts(products);
          })
          .catch(function (err) {
            console.warn('Recommendations API failed, trying fallback:', err);
            fetchFallbackProducts();
          });
      }).catch(function () {
        fetchFallbackProducts();
      });
    };

    function fetchFallbackProducts() {
      var activeContainer = document.getElementById('LuxuryRecommendations');
      var activeSlider = document.getElementById('LuxuryRecommendationsSlider');

      fetch('/products.json?limit=5')
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to fetch fallback products');
          return res.json();
        })
        .then(function (fallbackData) {
          renderProducts(fallbackData.products || []);
        })
        .catch(function (err) {
          console.warn('Fallback products also failed:', err);
          window.LuxuryRecommendationsFetching = false;
        });
    }

    function renderProducts(productList) {
      var activeContainer = document.getElementById('LuxuryRecommendations');
      var activeSlider = document.getElementById('LuxuryRecommendationsSlider');
      if (!activeContainer || !activeSlider) {
        window.LuxuryRecommendationsFetching = false;
        return;
      }

      function findProductImageForColor(prod, colorName) {
        if (!colorName || !prod.images || prod.images.length === 0) return '';
        var targetColor = colorName.toLowerCase().trim();

        // Calculate option index locally to ensure pure function scope
        var localColorOptionIndex = -1;
        if (prod.options) {
          for (var o = 0; o < prod.options.length; o++) {
            var opt = prod.options[o];
            var optName = (opt.name || '').toLowerCase();
            if (optName.indexOf('color') !== -1 || optName.indexOf('colour') !== -1 || optName.indexOf('metal') !== -1) {
              localColorOptionIndex = opt.position;
              break;
            }
          }
        }

        // 1. Search by variant_ids (for fallback products list)
        if (prod.variants && prod.variants.length > 0) {
          var matchingVariantIds = [];
          for (var v = 0; v < prod.variants.length; v++) {
            var variant = prod.variants[v];
            var vColor = '';
            if (localColorOptionIndex === 1) vColor = variant.option1;
            else if (localColorOptionIndex === 2) vColor = variant.option2;
            else if (localColorOptionIndex === 3) vColor = variant.option3;
            else {
              var opts = [variant.option1, variant.option2, variant.option3];
              for (var oi = 0; oi < opts.length; oi++) {
                if (opts[oi] && opts[oi].toLowerCase().trim() === targetColor) {
                  vColor = opts[oi];
                  break;
                }
              }
            }
            if (vColor && vColor.toLowerCase().trim() === targetColor) {
              matchingVariantIds.push(variant.id);
            }
          }

          if (matchingVariantIds.length > 0) {
            for (var imgIdx = 0; imgIdx < prod.images.length; imgIdx++) {
              var imgObj = prod.images[imgIdx];
              if (imgObj && imgObj.variant_ids && imgObj.variant_ids.length > 0) {
                for (var vi = 0; vi < imgObj.variant_ids.length; vi++) {
                  if (matchingVariantIds.indexOf(imgObj.variant_ids[vi]) !== -1) {
                    return imgObj.src || imgObj;
                  }
                }
              }
            }
          }
        }

        // 2. Search by direct alt text (for recommendations endpoint)
        for (var imgIdx = 0; imgIdx < prod.images.length; imgIdx++) {
          var imgObj = prod.images[imgIdx];
          var imgAlt = ((imgObj && imgObj.alt) || '').toLowerCase().trim();
          if (imgAlt === targetColor) {
            return imgObj.src || imgObj;
          }
        }

        for (var imgIdx = 0; imgIdx < prod.images.length; imgIdx++) {
          var imgObj = prod.images[imgIdx];
          var imgAlt = ((imgObj && imgObj.alt) || '').toLowerCase().trim();
          if (imgAlt && (imgAlt.indexOf(targetColor) !== -1 || targetColor.indexOf(imgAlt) !== -1)) {
            return imgObj.src || imgObj;
          }
        }

        // 3. Fallback to filename patterns (e.g. _y_ for Yellow, _w_ for White, _r_ for Rose)
        var charMap = {
          'yellow': '_y_',
          'white': '_w_',
          'rose': '_r_'
        };
        var pattern = charMap[targetColor];
        for (var imgIdx = 0; imgIdx < prod.images.length; imgIdx++) {
          var imgObj = prod.images[imgIdx];
          var imgSrc = ((imgObj && (imgObj.src || imgObj)) || '').toLowerCase();
          if (imgSrc) {
            if (pattern && imgSrc.indexOf(pattern) !== -1) {
              return imgObj.src || imgObj;
            }
            if (imgSrc.indexOf(targetColor) !== -1) {
              return imgObj.src || imgObj;
            }
          }
        }

        // 4. Default: first product image
        return prod.images[0].src || prod.images[0];
      }

      if (!productList || productList.length === 0) {
        window.LuxuryRecommendationsFetching = false;
        return;
      }

      // Cache the product list so we can redraw it without hitting network APIs
      cachedRecommendations = productList;

      var html = '';
      for (var i = 0; i < productList.length; i++) {
        var product = productList[i];

        var productUrl = product.url;
        if (!productUrl && product.handle) {
          productUrl = '/products/' + product.handle;
        }

        var rawPrice = product.price;
        if (rawPrice === undefined && product.variants && product.variants.length > 0) {
          rawPrice = product.variants[0].price;
        }

        var priceStr = '';
        if (rawPrice !== undefined && rawPrice !== null) {
          var cents = 0;
          if (typeof rawPrice === 'string') {
            var floatPrice = parseFloat(rawPrice);
            if (!isNaN(floatPrice)) {
              if (rawPrice.indexOf('.') !== -1) {
                cents = Math.round(floatPrice * 100);
              } else {
                cents = parseInt(rawPrice, 10);
              }
            }
          } else {
            cents = parseInt(rawPrice, 10);
          }

          if (window.Shopify && window.Shopify.formatMoney) {
            var fmt = (window.theme && window.theme.moneyFormat) || '₹{{amount}}';
            priceStr = Shopify.formatMoney(cents, fmt);
          } else {
            priceStr = '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
          }
        }

        var colorOptionIndex = -1;
        if (product.options) {
          for (var o = 0; o < product.options.length; o++) {
            var opt = product.options[o];
            var optName = (opt.name || '').toLowerCase();
            if (optName.indexOf('color') !== -1 || optName.indexOf('colour') !== -1 || optName.indexOf('metal') !== -1) {
              colorOptionIndex = opt.position;
              break;
            }
          }
        }

        var colors = [];
        var colorMap = {
          'gold': '#D4AF37',
          'yellow gold': '#D4AF37',
          'yellow': '#D4AF37',
          'silver': '#C0C0C0',
          'sterling silver': '#C0C0C0',
          'rose gold': '#E0A99A',
          'rose': '#E0A99A',
          'white gold': '#E5E4E2',
          'white': '#E5E4E2',
          'pearl': '#FFFFFF',
          'black': '#111111',
          'onyx': '#111111',
          'green': '#50C878',
          'emerald': '#50C878',
          'blue': '#0F52BA',
          'sapphire': '#0F52BA',
          'ruby': '#E0115F',
          'red': '#E0115F'
        };

        var defaultColorVal = '';
        if (product.variants && product.variants.length > 0) {
          var hasYellow = false;
          for (var v = 0; v < product.variants.length; v++) {
            var vObj = product.variants[v];
            var vColor = '';
            if (colorOptionIndex === 1) vColor = vObj.option1;
            else if (colorOptionIndex === 2) vColor = vObj.option2;
            else if (colorOptionIndex === 3) vColor = vObj.option3;
            else {
              var opts = [vObj.option1, vObj.option2, vObj.option3];
              for (var oi = 0; oi < opts.length; oi++) {
                if (opts[oi] && opts[oi].toLowerCase().trim() === 'yellow') {
                  vColor = opts[oi];
                  break;
                }
              }
            }

            if (vColor && vColor.toLowerCase().trim() === 'yellow') {
              hasYellow = true;
              defaultColorVal = vColor;
              break;
            }
          }

          if (!hasYellow) {
            var defaultVariant = product.variants[0];
            if (colorOptionIndex === 1) defaultColorVal = defaultVariant.option1;
            else if (colorOptionIndex === 2) defaultColorVal = defaultVariant.option2;
            else if (colorOptionIndex === 3) defaultColorVal = defaultVariant.option3;
            else {
              var opts = [defaultVariant.option1, defaultVariant.option2, defaultVariant.option3];
              for (var oi = 0; oi < opts.length; oi++) {
                if (opts[oi] && colorMap[opts[oi].toLowerCase().trim()] !== undefined) {
                  defaultColorVal = opts[oi];
                  break;
                }
              }
            }
          }
        }

        // Dynamically find and set the initial image of the active/default color variant
        var defaultVariantImg = findProductImageForColor(product, defaultColorVal);

        var imgUrl = defaultVariantImg;
        if (!imgUrl) {
          if (product.featured_image) {
            imgUrl = product.featured_image;
          } else if (product.images && product.images.length > 0) {
            imgUrl = product.images[0].src || product.images[0];
          }
        }

        if (imgUrl && imgUrl.indexOf('//') === 0) {
          imgUrl = 'https:' + imgUrl;
        }

        if (product.variants && product.variants.length > 0) {
          var seenColors = {};
          for (var v = 0; v < product.variants.length; v++) {
            var variant = product.variants[v];
            var optVal = null;
            if (colorOptionIndex === 1) optVal = variant.option1;
            else if (colorOptionIndex === 2) optVal = variant.option2;
            else if (colorOptionIndex === 3) optVal = variant.option3;
            else {
              var optionsToCheck = [variant.option1, variant.option2, variant.option3];
              for (var oIdx = 0; oIdx < optionsToCheck.length; oIdx++) {
                var cleanVal = (optionsToCheck[oIdx] || '').toLowerCase().trim();
                if (colorMap[cleanVal] !== undefined) {
                  optVal = optionsToCheck[oIdx];
                  break;
                }
              }
            }

            if (optVal) {
              var cleanVal = optVal.toLowerCase().trim();
              var matchedHex = null;

              if (colorMap[cleanVal] !== undefined) {
                matchedHex = colorMap[cleanVal];
              } else {
                var colorKeys = Object.keys(colorMap);
                for (var k = 0; k < colorKeys.length; k++) {
                  if (cleanVal.indexOf(colorKeys[k]) !== -1) {
                    matchedHex = colorMap[colorKeys[k]];
                    break;
                  }
                }
              }

              if (matchedHex) {
                var colorKey = cleanVal;
                if (!seenColors[colorKey]) {
                  seenColors[colorKey] = true;
                  var optImgUrl = findProductImageForColor(product, optVal);
                  colors.push({ name: optVal, hex: matchedHex, image: optImgUrl, variantId: variant.id });
                }
              }
            }
          }
        }

        var colorHtml = '';
        if (colors.length > 0) {
          colorHtml += '<div class="luxury-rec-card__colors">';
          for (var c = 0; c < colors.length; c++) {
            var col = colors[c];
            var isActive = (defaultColorVal && col.name.toLowerCase().trim() === defaultColorVal.toLowerCase().trim());
            var activeClass = isActive ? ' active' : '';
            colorHtml += '<span class="luxury-rec-card__color-swatch' + activeClass + '" style="background-color: ' + col.hex + ';" title="' + col.name + '" data-image="' + col.image + '" data-variant-id="' + col.variantId + '"></span>';
          }
          colorHtml += '</div>';
        }

        html += '<a href="' + productUrl + '" class="luxury-rec-card">' +
          '<div class="luxury-rec-card__image-wrapper">' +
          '<img src="' + imgUrl + '" alt="' + product.title + '" loading="lazy">' +
          '</div>' +
          '<p class="luxury-rec-card__title">' + product.title + '</p>' +
          '<div class="luxury-rec-card__footer">' +
          (priceStr ? '<p class="luxury-rec-card__price">' + priceStr + '</p>' : '') +
          colorHtml +
          '</div>' +
          '</a>';
      }
      activeSlider.innerHTML = html;
      activeContainer.style.display = 'block';
      window.LuxuryRecommendationsFetching = false;
    }

    window.refreshRecommendations();
  }

  /* ─── MutationObserver to watch for morphed DOM elements ────── */
  function initMutationObserver() {
    if (typeof window.MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutationsList) {
      var container = document.getElementById('LuxuryRecommendations');
      if (container && window.refreshRecommendations) {
        var slider = document.getElementById('LuxuryRecommendationsSlider');
        if (slider && !slider.querySelector('.luxury-rec-card')) {
          // Render cached recommendations if they exist, otherwise fetch
          window.refreshRecommendations();
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ─── Render dynamic coupon pills in cart drawer ─────────────── */
  function renderAppliedCoupons(appliedCodes) {
    var container = document.getElementById('LuxuryAppliedCoupons');
    if (!container) return;

    if (appliedCodes.length === 0) {
      container.style.display = 'none';
      container.innerHTML = '';
      return;
    }

    container.style.display = 'flex';
    var html = '';
    appliedCodes.forEach(function (code) {
      html += '<div class="luxury-coupon-pill" data-discount-code="' + code + '">' +
        '<span class="luxury-coupon-pill__icon">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
        '</span>' +
        '<span class="luxury-coupon-pill__code">' + code + '</span>' +
        '<button type="button" class="luxury-coupon-pill__remove" aria-label="Remove coupon ' + code + '">' +
        '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '</button>' +
        '</div>';
    });
    container.innerHTML = html;
  }

  /* ─── UI states ─────────────────────────────────────────────── */
  function setAppliedState(appliedCodes) {
    var couponChip = document.getElementById('LuxuryCouponChip');
    var applyBtn = document.getElementById('LuxuryPromoApply');
    var input = document.getElementById('LuxuryPromoInput');

    var isWelcomeApplied = appliedCodes.indexOf(COUPON_CODE.toUpperCase()) !== -1;
    if (couponChip) {
      var actionEl = couponChip.querySelector('.luxury-coupon-chip__action');
      if (isWelcomeApplied) {
        couponChip.classList.add('luxury-coupon-chip--applied');
        if (actionEl) actionEl.textContent = 'Applied ✓';
      } else {
        couponChip.classList.remove('luxury-coupon-chip--applied');
        if (actionEl) actionEl.textContent = 'Enter the code to apply';
      }
    }
    if (input) {
      input.value = '';
      input.disabled = true;
    }
    if (applyBtn) {
      applyBtn.textContent = 'Applied';
      applyBtn.disabled = true;
      applyBtn.style.opacity = '0.5';
    }
    hideMessage();
  }

  function setDefaultState() {
    var couponChip = document.getElementById('LuxuryCouponChip');
    var applyBtn = document.getElementById('LuxuryPromoApply');
    var input = document.getElementById('LuxuryPromoInput');

    if (couponChip) {
      couponChip.classList.remove('luxury-coupon-chip--applied');
      var actionEl = couponChip.querySelector('.luxury-coupon-chip__action');
      if (actionEl) actionEl.textContent = 'Enter the code to apply';
    }
    if (input) { input.value = ''; input.disabled = false; }
    if (applyBtn) {
      applyBtn.textContent = 'Apply';
      applyBtn.disabled = false;
      applyBtn.style.opacity = '1';
    }
    hideMessage();
  }

  /* ─── Update subtotal display ───────────────────────────────── */
  function updateTotalDisplay(cents) {
    var el = document.getElementById('LuxuryCartTotal');
    if (!el) return;

    var formatted = '';
    /* Use Shopify's own money formatter if available */
    if (window.Shopify && window.Shopify.formatMoney) {
      // Force '₹{{amount}}' to guarantee decimals are consistently formatted with the server
      var fmt = '₹{{amount}}';
      formatted = Shopify.formatMoney(cents, fmt);
    } else {
      formatted = '₹' + (cents / 100).toFixed(2);
    }

    // Standardize currency formatting to always show the rupees symbol
    formatted = formatted.replace(/Rs\.?/gi, '₹').trim();
    el.textContent = formatted;
  }

  /* ─── Event handlers ────────────────────────────────────────── */
  function handleManualApply(e) {
    e.preventDefault();
    var input = document.getElementById('LuxuryPromoInput');
    var code = input ? (input.value || '').trim() : '';

    if (!code) {
      showMessage('Please enter a promo code.', '#E54E26');
      return;
    }

    setButtonLoading(true);

    applyDiscountSilently(code).then(function (cart) {
      var appliedCodes = getAppliedDiscountCodes(cart);
      var isApplied = appliedCodes.some(function (c) {
        return c.toUpperCase() === code.toUpperCase();
      });
      if (isApplied) {
        sessionStorage.setItem('luxuryCouponApplied', 'true');
        setAppliedState(appliedCodes);
        updateTotalDisplay(cart.total_price);
        renderAppliedCoupons(appliedCodes);
        showMessage('Coupon applied successfully!', '#2E7D32');
      } else {
        setButtonLoading(false);
        showMessage('Invalid or expired coupon code.', '#E54E26');
      }
    }).catch(function () {
      setButtonLoading(false);
      showMessage('Something went wrong. Please try again.', '#E54E26');
    });
  }

  function handleRemoveDiscount() {
    setButtonLoading(true);
    removeDiscountSilently().then(function () {
      sessionStorage.removeItem('luxuryCouponApplied');
      syncUIWithCart();
    });
  }

  function handleChipClick() {
    var couponChip = document.getElementById('LuxuryCouponChip');
    if (!couponChip || couponChip.classList.contains('luxury-coupon-chip--applied')) return;

    var input = document.getElementById('LuxuryPromoInput');
    if (input) input.value = COUPON_CODE;
    setButtonLoading(true);

    applyDiscountSilently(COUPON_CODE).then(function (cart) {
      var appliedCodes = getAppliedDiscountCodes(cart);
      var isApplied = appliedCodes.some(function (c) {
        return c.toUpperCase() === COUPON_CODE.toUpperCase();
      });
      if (isApplied) {
        sessionStorage.setItem('luxuryCouponApplied', 'true');
        setAppliedState(appliedCodes);
        updateTotalDisplay(cart.total_price);
        renderAppliedCoupons(appliedCodes);
        showMessage('Coupon applied successfully!', '#2E7D32');
      } else {
        setButtonLoading(false);
        showMessage('Could not apply coupon. Please try manually.', '#E54E26');
      }
    }).catch(function () {
      setButtonLoading(false);
      showMessage('Something went wrong. Please try again.', '#E54E26');
    });
  }

  function setButtonLoading(loading) {
    var applyBtn = document.getElementById('LuxuryPromoApply');
    if (!applyBtn) return;
    applyBtn.textContent = loading ? 'Applying…' : 'Apply';
    applyBtn.disabled = loading;
    applyBtn.style.opacity = loading ? '0.5' : '1';
  }

  /* ─── Message helpers ───────────────────────────────────────── */
  function showMessage(text, color) {
    var msg = document.getElementById('LuxuryPromoMessage');
    if (!msg) return;
    msg.textContent = text;
    msg.style.color = color || '#111111';
    msg.style.display = 'block';
  }

  function hideMessage() {
    var msg = document.getElementById('LuxuryPromoMessage');
    if (msg) msg.style.display = 'none';
  }

  /* ─── Boot ──────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
